/**
 * Created by inonstelman on 1/6/15.
 */
(function () {
    'use strict';

    // @ngInject
    Services.ExceptionService = function ExceptionService(AppConfigService, $injector) {

        return {
            formatException: function formatLogEntry(exception) {
                var $location;
                var usersManager;

                $location = $location || $injector.get('$location');
                usersManager = usersManager || $injector.get('UsersManager');

                if(exception) {
                    var currUser = usersManager.getCurrUser();

                    var logMessage = "--Exception-- " + exception.name + "\n\n Message: " + exception.message + " \n\n";
                    logMessage += " User: " + (currUser ? currUser.printDetails() : 'N/A') + " \n\n Location: " + ($location ? $location.absUrl(): 'N/A') + " \n\n";
                    logMessage += " Stack: " + exception.stack;

                    return logMessage;
                } else {
                    return "No exception was provided";
                }
            }
        };
    };

}());

